import React from 'react';

class ErrMsg extends React.Component {

    constructor() {
        super();
        this.fechar = this.fechar.bind(this);
    }

    fechar() {
        this.props.fechar();
    }

    render() {
        return (
            <div id="dashboard-err-msg">
                <p id="dashboard-err-msg-fechar-btn" onClick={ this.fechar }>
                    Fechar
                </p>
                <p id="dashboard-err-msg-txt">
                    { this.props.msg }
                </p>
            </div>
        );
    }

}

export default ErrMsg;

